import React from "react";
import { toLocalInputValue } from "../lib/time";

const ProjectForm = ({ project, onChange, onSave, saving, disabled }) => {
  const set = (field) => (e) => onChange(field, e.target.value);

  return (
    <section>
      <header className="mb-4 flex items-baseline justify-between">
        <span className="section-eyebrow">Project</span>
        <button
          type="button"
          onClick={onSave}
          disabled={saving || disabled}
          className="btn-primary"
        >
          {saving ? "Saving…" : "Save changes"}
        </button>
      </header>

      <div className="grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-2">
        <div className="field md:col-span-2">
          <label className="label">Title</label>
          <input
            type="text"
            value={project.title}
            onChange={set("title")}
            placeholder="Untitled project"
            className="input"
            disabled={disabled}
          />
        </div>

        <div className="field">
          <label className="label">Customer</label>
          <input
            type="text"
            value={project.customer}
            onChange={set("customer")}
            placeholder="Customer name"
            className="input"
            disabled={disabled}
          />
        </div>

        <div className="field">
          <label className="label">Start</label>
          <input
            type="datetime-local"
            value={toLocalInputValue(project.startAt)}
            onChange={set("startAt")}
            className="input-mono"
            disabled={disabled}
          />
        </div>

        <div className="field">
          <label className="label">Disconnect location</label>
          <input
            type="text"
            value={project.disconnectLocation}
            onChange={set("disconnectLocation")}
            placeholder="Field / coordinates"
            className="input"
            disabled={disabled}
          />
        </div>

        <div className="field">
          <label className="label">Connect location</label>
          <input
            type="text"
            value={project.connectLocation}
            onChange={set("connectLocation")}
            placeholder="Field / coordinates"
            className="input"
            disabled={disabled}
          />
        </div>

        <div className="field">
          <label className="label">Rig</label>
          <input
            type="text"
            value={project.rig}
            onChange={set("rig")}
            placeholder="Rig identifier"
            className="input"
            disabled={disabled}
          />
        </div>

        <div className="field">
          <label className="label">Vessel</label>
          <input
            type="text"
            value={project.vessel}
            onChange={set("vessel")}
            placeholder="Vessel name"
            className="input"
            disabled={disabled}
          />
        </div>
      </div>
    </section>
  );
};

export default ProjectForm;
